export const FORM_NAME = 'CUSTOMER_PROFILE_FORM';
export const MODAL_QA_ID = 'MODAL_QA_ID';
export const ADD_PHARMACY = 'Add Pharmacy';
export const MISSING_INFO_TITLE = 'Missing Information:';
// SUBFORMS TITLES
export const PHARMACY_INFORMATION = 'Pharmacy Information';
export const HEALTH_SYSTEM_INFORMATION = 'Health System Information';
export const LOGINS_ACCOUNTS = 'Logins + Accounts';
export const VOICEMAIL_FAX_INFO = 'Voicemail and Fax info';
export const CLINIC_ASSIGMENTS = 'Clinic Assignments';
export const TALKDESK = 'Talkdesk';
// Dynamic fields
export enum HsiDynamicFieldsEnum {
  POOL_NAMES = 'hsi_pool_names',
  POOL_CLINIC_REFERENCE = 'hsi_pool_clinic_reference',
  SURESCRIPTS_NAME = 'hsi_sure_script_name',
  SURESCRIPTS_CLINIC_REFERENCE = 'hsi_sure_script_clinic_reference',
  PRINTER = 'hsi_printer',
  PRINTER_CLINIC_REFERENCE = 'hsi_printer_clinic_reference',
}

export enum HsiDynamicPairFieldsEnum {
  POOL_NAMES = 'hsi_pool_names',
  POOL_CLINIC_REFERENCE = 'hsi_pool_clinic_reference',
  SURESCRIPTS_NAME = 'hsi_sure_script_name',
  SURESCRIPTS_CLINIC_REFERENCE = 'hsi_sure_script_clinic_reference',
  PRINTER = 'hsi_printer',
  PRINTER_CLINIC_REFERENCE = 'hsi_printer_clinic_reference',
}

export enum LaDynamicPairFieldsEnum {
  SITE = 'la_site',
  SITE_USERNAME = 'la_site_username',
  SITE_PASSWORD = 'la_site_password',
  FOUNDATION = 'la_foundation',
  FOUNDATION_USERNAME = 'la_foundation_usernamer',
  FOUNDATION_PASSWORD = 'la_foundation_password',
  SUPPLY_ORDER = 'la_supply_order',
  SUPPLY_ORDER_USERNAME = 'la_supply_order_username',
  SUPPLY_ORDER_PASSWORD = 'la_supply_order_password',
}

export enum TalkdeskDynamicFieldsEnum {
  TALKDESK_PRIMARY = 'talkdesk_primary',
  TALKDESK_SECONDARY = 'talkdesk_secondary',
  TALKDESK_CARDIOLOGY_PRIMARY = 'talkdesk_cardiology_primary',
  TALKDESK_CARDIOLOGY_SECONDARY = 'talkdesk_cardiology_secondary',
}

export enum VoicemailDynamicFieldsEnum {
  VOICEMAIL_FAX_INFO = 'voicemail_fax_info',
}

export enum ClinicAssignmentsDynamicFieldsEnum {
  CLINIC_ASSIGMENTS_NAME = 'ca_name',
  CLINIC_ASSIGMENTS_OFFICE_LOCATIONS = 'ca_office_locations',
  CLINIC_ASSIGMENTS_PHARMACISTS = 'ca_pharmacists',
  CLINIC_ASSIGMENTS_LIAISONS = 'ca_liaisons',
}

export enum loginsAccountsPrefixEnum {
  SITE = 'site',
  FOUNDATIONS = 'fo',
  SUPPLY_ORDER = 'so',
}

export enum talkdeskInnersections {
  DOWNLOAD_TALKDESK = 'How To Download Talkdesk',
  TALKDESK_LINES = 'Talkdesk Lines',
  RING_GROUPS = 'Ring Groups',
}

export enum talkdeskLinesSpecialties {
  CARDIOLOGY = 'Cardiology',
  ONCOLLOGY = 'Oncology',
}

export enum ringGroupSubSections {
  CENTRAL_OPS_DISPENSING = 'Central Ops / Dispensing',
  CARDIOLOGY = 'Cardiology',
}
// Existing USA timezones in ARBOR
export const ARBOR_TIME_ZONES = [
  {
    label: 'EST/EDT',
    value: 'America/New_York',
  },
  {
    label: 'PST/PDT',
    value: 'America/Los_Angeles',
  },
  {
    label: 'CST/CDT',
    value: 'America/Chicago',
  },
  {
    label: 'HST',
    value: 'Pacific/Honolulu',
  },
  {
    label: 'MST/MDT',
    value: 'America/Denver',
  },
];

export const SITE_DROPDOWN = [
  {
    label: 'Zitter',
    value: 'zitter',
  },
  {
    label: 'Docusign',
    value: 'docusign',
  },
  {
    label: 'CMM',
    value: 'cmm',
  },
];

export const FOUNDATIONS_DROPDOWN = [
  {
    label: 'Healthwell',
    value: 'healthwell',
  },
  {
    label: 'The Assistance Fund',
    value: 'taf',
  },
  {
    label: 'Patient Assistance Fund',
    value: 'paf',
  },
];

export const SUPPLY_ORDER_DROPDOWN = [
  {
    label: 'ULINE ',
    value: 'uline',
  },
  {
    label: 'ODP',
    value: 'odp',
  },
  {
    label: 'Staples ',
    value: 'staples ',
  },
];

// Pharmacy Information fields mapping
export const PHARMACY_INFORMATION_MAPPING = [
  { fieldName: 'site', nickName: 'site' },
  { fieldName: 'pi_dba', nickName: 'dba' },
  { fieldName: 'pi_hour_start', nickName: 'hours_start' },
  { fieldName: 'pi_hour_end', nickName: 'hours_end' },
  { fieldName: 'pi_timezone', nickName: 'timezone' },
  { fieldName: 'pi_npi', nickName: 'npi' },
  { fieldName: 'pi_dea', nickName: 'dea' },
  { fieldName: 'pi_ncpdp', nickName: 'ncpdp' },
  { fieldName: 'pi_state_license', nickName: 'state_license_num' },
  { fieldName: 'pi_tax_id', nickName: 'tax_id' },
  { fieldName: 'pi_cost_center', nickName: 'cost_center' },
  { fieldName: 'pi_psao', nickName: 'psao' },
  { fieldName: 'pi_emr', nickName: 'emr' },
  { fieldName: 'pi_dispensing_system', nickName: 'dispensing_system' },
  { fieldName: 'pi_pos', nickName: 'pos_system' },
  { fieldName: 'pi_sure_script_name', nickName: 'surescript_name' },
  { fieldName: 'pi_right_fax_lines', nickName: 'rightfax_lines' },
  { fieldName: 'pi_talkdesk_lines', nickName: 'talkdesk_lines' },
  { fieldName: 'pi_printers', nickName: 'printers' },
  { fieldName: 'pi_wholesaler', nickName: 'wholesaler' },
  { fieldName: 'pi_wholesaler_wac', nickName: 'wholesaler_wac' },
  { fieldName: 'pi_wholesaler_340b', nickName: 'wholesaler_340b' },
  { fieldName: 'pi_wholesaler_website', nickName: 'wholesaler_website' },
  { fieldName: 'pi_medicaid_enrollment_unit', nickName: 'medicaid_enrollment_unit' },
  { fieldName: 'pi_state_medicaid_number', nickName: 'state_medicaid_num' },
  { fieldName: 'pi_medicaid_submitter_id', nickName: 'medicaid_submitter_id' },
  { fieldName: 'pi_pharmacy_staff', nickName: 'pharmacy_staff' },
  { fieldName: 'pi_pharmacy_operations', nickName: 'supervisor_pharmacy_operations_id' },
  { fieldName: 'pi_clinical_pharmacist', nickName: 'clinical_pharmacist_id' },
  { fieldName: 'pi_pharmacy_technician', nickName: 'pharmacy_technician_id' },
];

// Health System Information fields mapping
export const HEALTH_SYSTEM_INFORMATION_MAPPING = [
  { fieldName: 'hsi_dba', nickName: 'dba' },
  { fieldName: 'hsi_emr', nickName: 'emr' },
  { fieldName: 'hsi_dispensing_system', nickName: 'dispensing_system' },
  { fieldName: 'hsi_wholesaler', nickName: 'wholesaler' },
  { fieldName: 'hsi_pos_system', nickName: 'pos_system' },
  { fieldName: 'hsi_medicaid_enrollment_unit', nickName: 'medicaid_enrollment_unit' },
  { fieldName: 'hsi_state_medicaid_number', nickName: 'state_medicaid_num' },
  { fieldName: 'hsi_medicaid_submitter_id', nickName: 'medicaid_submitter_id' },
  { fieldName: 'hsi_340b_id', nickName: '340b_id' },
  { fieldName: 'hsi_cost_center', nickName: 'cost_center' },
  { fieldName: 'hsi_shared_email', nickName: 'shared_email' },
  { fieldName: 'hsi_distribution_list_email', nickName: 'distribution_list_email' },
  { fieldName: 'hsi_pool_names', nickName: 'pool_names' },
  { fieldName: 'hsi_pool_clinic_reference', nickName: 'pool_clinic_references' },
  { fieldName: 'hsi_sure_script_name', nickName: 'surescript_name' },
  { fieldName: 'hsi_sure_script_clinic_reference', nickName: 'surescript_clinic_references' },
  { fieldName: 'hsi_printer', nickName: 'printers' },
  { fieldName: 'hsi_printer_clinic_reference', nickName: 'printers_clinic_references' },
  { fieldName: 'hsi_additional_information', nickName: 'additional_information' },
];

// Logins + Accounts Information fields mapping
export const LOGINS_ACCOUNTS_MAPPING = [
  { fieldName: 'la_site_username', nickName: 'site_???_username' },
  { fieldName: 'la_site_password', nickName: 'site_???_password' },
  { fieldName: 'la_foundation_usernamer', nickName: 'fo_???_username' },
  { fieldName: 'la_foundation_password', nickName: 'fo_???_password' },
  { fieldName: 'la_supply_order_username', nickName: 'so_???_username' },
  { fieldName: 'la_supply_order_password', nickName: 'so_???_password' },
];

// Voicemail and Fax Info fields mapping
export const VOICEMAIL_FAX_INFO_MAPPING = [
  { fieldName: 'voicemail_fax_info', nickName: 'voicemail_fax_info' },
];

// Clinic Assigments fields mapping
export const CLINIC_ASSIGMENTS_MAPPING = [
  { fieldName: 'ca_name', nickName: 'name' },
  { fieldName: 'ca_office_locations', nickName: 'office_locations' },
];

export enum RolesEnum {
  PHARMACIST = 'pharmacist',
  LIAISON = 'liaison',
  LIAISON_CENTRAL_OPS = 'liaison_central_ops',
  LIAISON_DISPENSING = 'liaison_dispensing',
  PHARMACIST_CENTRAL_OPS = 'pharmacist_central_ops',
  PHARMACIST_DISPENSING = 'pharmacist_dispensing',
}
